var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58366 19.0039C4.87533 19.0039 1.04199 15.1706 1.04199 10.4622C1.04199 5.75391 4.87533 1.92057 9.58366 1.92057C14.292 1.92057 18.1253 5.75391 18.1253 10.4622C18.1253 15.1706 14.292 19.0039 9.58366 19.0039ZM9.58366 3.17057C5.55866 3.17057 2.29199 6.44557 2.29199 10.4622C2.29199 14.4789 5.55866 17.7539 9.58366 17.7539C13.6087 17.7539 16.8753 14.4789 16.8753 10.4622C16.8753 6.44557 13.6087 3.17057 9.58366 3.17057Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 19.8372C18.1752 19.8372 18.0169 19.7789 17.8919 19.6539L16.2252 17.9872C15.9835 17.7456 15.9835 17.3456 16.2252 17.1039C16.4669 16.8622 16.8669 16.8622 17.1085 17.1039L18.7752 18.7706C19.0169 19.0122 19.0169 19.4122 18.7752 19.6539C18.6502 19.7789 18.4919 19.8372 18.3335 19.8372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.632ef8f861e100c5bb2143c76964bb2c.svg";
export { ForwardRef as ReactComponent };